import { html, View } from 'rune-ts';
import klass from './CateRootGnbMo.module.scss';
import { getCateRootMenuMo } from '@services/MarppleShop/renderApp/components/cells/Header/libs/contants/menu.ts';
import { CategoryLevel1_CODE } from '../../../../../../shared/mps-shared/domain/category/types.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { htmlIf } from '@services/MarppleShop/shared/util/index.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';

export interface CateRootGnbMoDataView {
  readonly cate_root_code?: CategoryLevel1_CODE | 'RECOMMEND';
}

export class CateRootGnbMoView extends View<CateRootGnbMoDataView> {
  constructor(data: CateRootGnbMoDataView) {
    super(data);
  }

  override template() {
    return html`<div class="${klass.cate_root_gnb_mo} ${font('14_medium')}">
      ${getCateRootMenuMo(this.data.cate_root_code).map((gnb) => {
        return html`<a
          href="${gnb.url}"
          target="${gnb.target || '_self'}"
          class="${klass.gnb} ${htmlIf(klass.gnb_selected, gnb.is_selected)} ${font(
            gnb.is_selected ? '14_bold' : '14_medium',
          )}"
          ${gnb.postMessage ? html`data-post-message="${dataStr(gnb.postMessage)}"` : ''}
        >
          ${gnb.name}
        </a>`;
      })}
    </div> `;
  }
}
